import { useTranslation } from 'react-i18next';
import { CrmBoard } from '@features/crm-board';

export function CrmPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-6">
      <header>
        <h1 className="text-2xl font-semibold">{t('crm.title')}</h1>
        <p className="text-sm opacity-70">{t('crm.subtitle')}</p>
      </header>
      <CrmBoard />
    </div>
  );
}
